import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import jwtDecode from "jwt-decode";
import { withStyles } from "@material-ui/core/styles";
import { Paper, Divider } from "@material-ui/core";
import { TableContainer, Table, TableBody } from "@material-ui/core";
import Axios from "axios";

import Header from "../../../../Component/NavBar/User/Header/Header";
import Footer from "../../../../Component/NavBar/User/Footer/Footer";
import { url } from "../../../../config/config";
import CustomTableHead from "../../../../Component/Table/CustomTableHead/CustomTableHead";
import CustomTableFooter from "../../../../Component/Table/CutomTableFooter/CustomTableFooter";
import CustomLoader from "../../../../Component/CustomLoader/CustomLoader";
import CustomEmptyMessage from "../../../../Component/CustomEmptyMessage/CustomEmptyMessage";
import { useStyles } from "./CustomerMyBooks.css";
import MyBooksBody from "./MyBooksBody/MyBooksBody";
import MobileMyBooks from "./MobileMyBooks/MobileMyBooks";

class CustomerMyBooks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      rowsPerPage: 5,
      column: [
        {
          name: "S.N.",
        },
        {
          name: "Cover Image",
        },
        {
          name: "Title",
        },
        {
          name: "Author",
        },
        {
          name: "Genre",
        },
        {
          name: "Published Date",
        },
      ],
      soldBooks: [],
      myBooks: [],
      isEmpty: false,
    };
  }

  componentDidMount() {
    this.decodeData(this.props.userToken);
    this.getMyBooks(this.props.userToken);
  }

  getMyBooks = async (userToken) => {
    const response = await Axios.get(`${url}/api/sold/mybooks`, {
      headers: {
        "x-auth-token": userToken,
      },
    });
    if (response.data.length !== 0) {
      response.data.map((data) =>
        data.itemDetails.map((book) =>
          this.setState({
            myBooks: [...this.state.myBooks, book],
            isEmpty: false,
          })
        )
      );
      this.state.myBooks.map(async (book) => {
        const response2 = await Axios.get(`${url}/api/books/${book.bookId}`);
        if (response2.data.length !== 0) {
          this.setState({
            soldBooks: [...this.state.soldBooks, response2.data],
          });
        } else {
          this.setState({
            soldBooks: [],
          });
        }
      });
    } else {
      this.setState({
        myBooks: [],
        isEmpty: true,
      });
    }
  };

  decodeData = (userToken) => {
    try {
      let userData = jwtDecode(userToken);
      this.setState({
        name: userData.firstName + " " + userData.lastName,
      });
    } catch (error) {}
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const { page, rowsPerPage } = this.state;
    return (
      <div>
        <Header />
        <div className={classes.root}>
          <div
            style={{
              fontSize: 30,
              display: "flex",
              justifyContent: "center",
              fontWeight: "bold",
            }}
          >
            My Books
          </div>
          <Divider />
          <br />
          {this.state.soldBooks.length !== 0 ? (
            <div>
              <Paper className={classes.sectionDesktop}>
                <TableContainer>
                  <Table>
                    <CustomTableHead column={this.state.column} />

                    <TableBody>
                      {this.state.soldBooks
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((book, index) => (
                          <MyBooksBody key={index} index={index} book={book} />
                        ))}
                    </TableBody>

                    <CustomTableFooter
                      count={this.state.soldBooks.length}
                      rowsPerPage={this.state.rowsPerPage}
                      page={this.state.page}
                      onChangePage={this.handlePage}
                      onChangeRowsPerPage={this.handleRowsPerPage}
                    />
                  </Table>
                </TableContainer>
              </Paper>
              <div className={classes.sectionMobile}>
                <MobileMyBooks books={this.state.soldBooks} />
              </div>
            </div>
          ) : this.state.isEmpty === true ? (
            <CustomEmptyMessage
              button={true}
              message="You haven't bought any books."
              buttonLabel="Start Buying"
              buttonUrl={() => this.props.history.push("/books")}
            />
          ) : (
            <CustomLoader />
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userToken: state.UserReducer.token,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(CustomerMyBooks)));
